import { addAccessToken, removeAccessToken } from "../constants/userConstant";

const AccessTokenData = {
  accessToken: null,
};

const AccessTokenReducer = (state = AccessTokenData, action) => {
  switch (action.type) {
    case addAccessToken:
      const { access_token } = action.payload;
      return { accessToken: access_token };
    case removeAccessToken:
      return { accessToken: null };
    default:
      return state;
  }
};

export default AccessTokenReducer;
